/// <reference path="./index.ts" />

import { IconType } from 'react-icons';
import { Sanity } from '../sanity';

export namespace Assets {
  export namespace Types {
    export enum Providers {
      MEDIA_SHUTTLE = 'media_shuttle',
      ASPERA = 'aspera',
    }

    export const ProviderNames: Record<Providers, string> = {
      [Providers.MEDIA_SHUTTLE]: 'Media Shuttle',
      [Providers.ASPERA]: 'Aspera',
    };

    export enum AuthenticationType {
      TOKEN = 'token',
      BASIC = 'basic'
    }

    export enum RecipientType {
      USER = 'user',
      GROUP = 'group'
    }

    export enum UserRole {

    }

    export enum ResponseStatus {
      SUCCESS = 'success',
      ERROR = 'error'
    }

    export enum PackageStatus {
      STARTING = 'starting',
      PROCESSING = 'processing',
      ACTIVE = 'active',
      FAILED = 'failed',
      EXPIRED = 'expired',
      WARNING = 'warning',
      CRITICAL = 'critical',
    }

    export enum TransferStatus {
      CANCELED = 'canceled',
      COMPLETED = 'completed',
      FAILED = 'failed',
      PARTIALLY_COMPLETED = 'partially_completed',
      PAUSED = 'paused',
      RUNNING = 'running',
      STARTING = 'starting',
      WAITING = 'waiting',
    }

    export enum Operation {
      REGENERATE = 'regenerate',
      STATUS = 'status'
    }

    export interface AssetProviderConfig {
      [key: string]: unknown;
      webhookSecret?: string;
    }

    export interface AssetPath {
      source: string;
      destination?: string;
    }

    export interface AssetSelection {
      paths: AssetPath[];
    }

    export enum FileType {
      FILE = 'file',
      DIRECTORY = 'directory',
      SYMBOLIC_LINK = 'symbolic_link'
    }

    export interface FileInfo {
      path: string;
      basename: string;
      type: FileType;
      size: number;
      mtime: string;
    }

    export type AssetIcon = React.ReactNode | IconType;

    export interface BrowseRequest {

    }

    export interface BrowseResponse {

    }

    export interface FileInfoRequest {

    }

    export interface FileInfoResponse {
    }

    export enum TransferDirection {
      SEND = 'send',
      RECEIVE = 'receive'
    }

    export enum PackageOperation {
      UPLOAD = 'upload',
      DOWNLOAD = 'download'
    }

    export interface Recipient {

    }

    export interface PackageData {

    }

    export interface PackageInfo {
      id: string;
    }

    export enum ExpiryStatus {
      NORMAL = 'normal',
      WARNING = 'warning',
      CRITICAL = 'critical'
    }

    export interface ExpiryStatusProps {
      isPackageExpired: boolean;
      isLinkExpired: boolean;
      isAnyExpired: boolean;
      statusText: string;
      warning: boolean;
    }
    export namespace Lambda {
      export interface RegenerateAssetsResponse {
        success: boolean;
        message: string;
        regeneratedPackages: Sanity.Types.OrderAssetPackage[];
        timestamp: string;
      }
      export interface WebhookPayload {
        type: Operation;
        data: {
          orderId: string;
          packageId?: string | string[];
        };
      }

      /**
       * @class LambdaError
       * @extends Error
       * @prop {string} name name of error
       * @prop {string} msg error message
       * @prop {string|number} statusCode http status code
       * @prop {string|number} status http status
       * @prop {*} otherProperties < ... (rest) - other properties to add >
       */
      export class LambdaError extends Error {
        public msg: string;
        public statusCode: string | number;
        public status: string | number;

        constructor(code: string | number, message: string, otherProperties?: Record<string, unknown>) {
          super(message);

          this.name = this.constructor.name;
          this.msg = message;
          this.statusCode = code;
          this.status = code;
          if (otherProperties) {
            Object.assign(this, otherProperties);
          }
          Error.captureStackTrace(this, this.constructor);
        }
      }
    }
  }
}
